// src/pages/Dashboards/AllDashboards.tsx

import { Collapse, Typography } from '@mui/material'
import { useEffect, useState } from 'react'

import { DashboardPool } from '@/types/domain/dashboard'

import { setStorage, getStorage } from '../../api/'
import {
  BtnAddDashboard,
  DlgDashboardCreate,
  usePreloader,
} from '../../components/'
import {
  OperatorData,
  useDashboardApi,
  useDashboardPool,
  useOperator,
} from '../../hooks/'
import useRenderCount from '../../hooks/tools/useRenderCount'

import { SingleDashboard } from './SingleDashboard'

type Props = {
  PAGE_CONFIG?: string
}

export const AllDashboards = ({
  PAGE_CONFIG = 'settings_dashboards',
}: Props) => {
  // render performance
  const rc = useRenderCount()
  console.log('AllDashboards', rc)

  const { isLoading } = usePreloader()

  const { save: saveDashboard } = useDashboardApi(null)
  const data: DashboardPool = useDashboardPool()

  const opData: OperatorData = useOperator()
  const user_id = opData?.id

  const [config, setConfig] = useState(getStorage(PAGE_CONFIG))
  useEffect(() => setStorage(PAGE_CONFIG, config), [config, PAGE_CONFIG])

  const [selectedId, setSelectedId] = useState(config?.selectedId ?? null)
  const showDlgAddDashboard = config?.showDlgAddDashboard ?? false

  const onOpenDlgAdd = () =>
    setConfig(prev => ({ ...prev, showDlgAddDashboard: true }))

  const onCloseDlgAdd = () =>
    setConfig(prev => ({ ...prev, showDlgAddDashboard: false }))

  const onSelectDashboard = selectedId => (_, isExpanded) => {
    setConfig(prev => ({
      ...prev,
      selectedId: isExpanded ? selectedId : null,
    }))
    setSelectedId(isExpanded ? selectedId : null)
  }

  const onCreate = name => {
    onCloseDlgAdd()
    saveDashboard({ name, user_id })
  }

  return (
    <>
      <DlgDashboardCreate
        open={showDlgAddDashboard}
        onCancel={onCloseDlgAdd}
        onConfirm={onCreate}
      />

      <Collapse in={true}>
        {data.map(item => (
          <SingleDashboard
            id={Number(item.id)}
            expanded={Number(item.id) === selectedId}
            key={item.id}
            onChange={onSelectDashboard(Number(item.id))}
          />
        ))}

        <Collapse in={!isLoading && data.length === 0}>
          <Typography sx={{ textAlign: 'center', py: 5 }} variant={'h6'}>
            Mit Klick auf &apos;+&apos; können Sie ein neues Dashboard
            erstellen.
          </Typography>
        </Collapse>
      </Collapse>

      <BtnAddDashboard onClick={onOpenDlgAdd} />
    </>
  )
}
